import { createRoute, createRouter, redirect } from "@tanstack/react-router";
import { rootRoute } from "./routes/root";
import { accountRoute } from "./routes/account";
import { errorsRoute } from "./routes/errors";
import { apiDocsRoute } from "./routes/api-docs";
import { newSandboxRoute, sandboxesRoute } from "./routes/sandboxes";

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  beforeLoad: () => {
    throw redirect({ to: "/account" });
  },
});

const routeTree = rootRoute.addChildren([
  indexRoute,
  accountRoute,
  errorsRoute,
  apiDocsRoute,
  sandboxesRoute,
  newSandboxRoute,
]);

export const router = createRouter({
  routeTree,
  basepath: import.meta.env.BASE_URL,
  // Redoc rewrites the URL hash from its own scroll-spy; TanStack's default
  // hash-scroll would then yank the viewport to that section, fighting the user
  // (badly when scrolling up). Redoc manages its own scroll, so disable it.
  defaultHashScrollIntoView: false,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
